// Experimental <modular-configurator-v2> - the layout-card / set-all-colors
// / "Make it yours" dialog take on assets/modular-configurator.js, rendered by
// the `modular_configurator_v2` block. Kept as a separate element so the
// original configurator stays untouched while this one is trialled; data
// model, stock resolution, pricing and cart bundling are the same.
(function () {
  if (customElements.get('modular-configurator-v2')) return;

  var DIRS = { E: [1, 0], S: [0, 1], W: [-1, 0], N: [0, -1] };
  var ORDER = ['E', 'S', 'W', 'N'];
  var CELL = 64;
  var GAP = 0;
  var PAD = 14;
  var CHECK_SVG =
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
    '<path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var ROTATE_SVG =
    '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M17.5 9.375C17.8452 9.375 18.125 9.65482 18.125 10V17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H5C4.65482 18.125 4.375 17.8452 4.375 17.5V10C4.375 9.65482 4.65482 9.375 5 9.375H17.5ZM5.625 16.875H16.875V10.625H5.625V16.875Z" fill="currentColor"/>' +
    '<path d="M1.875 3.33301C1.875 2.98783 2.15482 2.70801 2.5 2.70801C2.84518 2.70801 3.125 2.98783 3.125 3.33301V6.45801H6.25C6.59518 6.45801 6.875 6.73783 6.875 7.08301C6.875 7.42819 6.59518 7.70801 6.25 7.70801H2.5C2.15482 7.70801 1.875 7.42819 1.875 7.08301V3.33301Z" fill="currentColor"/>' +
    '<path d="M10.0001 1.875C12.6786 1.875 15.0542 3.17195 16.5333 5.16927C16.7387 5.44667 16.6805 5.83788 16.4031 6.04329C16.1257 6.24865 15.7345 6.19037 15.5291 5.91309C14.2756 4.2204 12.2657 3.125 10.0001 3.125C7.7771 3.125 5.80046 4.17932 4.54275 5.81787C4.5302 5.83422 4.51697 5.85004 4.50287 5.86507L2.95583 7.51139C2.71948 7.76287 2.32357 7.77532 2.07204 7.53906C1.82057 7.30271 1.80811 6.9068 2.04437 6.65527L3.57514 5.02604C5.06035 3.11013 7.38612 1.875 10.0001 1.875Z" fill="currentColor"/>' +
    '</svg>';

  // Solid-color swatches for Color values that aren't a fabric photo below.
  // Add entries as 'value name (lowercased)': '#hexcode'.
  var COLOR_HEX_BY_VALUE = {};

  // Maps a role's `shape_type` (merchant-configured, Configurator Module
  // metaobject field) to how a single module renders in the top-view
  // layout: 'A' (armless, optionally with an arm marker on one side) or 'C'
  // (corner, optionally an extended chaise). Ported from the seat-
  // configurator's SEAT_TYPE_BY_VALUE, keyed by shape_type instead of a
  // free-text Orientation option value.
  var SHAPE_TYPE_TABLE = {
    armless: { type: 'A' },
    // A straight seat with an arm on one side, distinct from `armless` (no
    // arm) and from `corner` (its side block is a full backrest that turns
    // the chain 90°, not an arm) - confirmed against Anchor's real
    // Armrest Left/Right top-view photos.
    armrest_left: { type: 'A', armSide: 'left' },
    armrest_right: { type: 'A', armSide: 'right' },
    corner: { type: 'C', turn: 'R', chaise: false },
    corner_chaise: { type: 'C', turn: 'R', chaise: true },
    // Geometrically the same as armless - the real top-view photo is what
    // visually differentiates an ottoman, matching how the old seat-
    // configurator already treated any unrecognized orientation value.
    ottoman: { type: 'A' },
  };

  // How many units of this variant Shopify will actually let this order
  // claim. `inventory_quantity` only means anything when Shopify tracks
  // inventory for it and it isn't set to oversell - otherwise (custom/no
  // tracking, or "continue selling when out of stock") supply is
  // effectively unlimited from this configurator's point of view.
  function variantStockLimit(variant) {
    if (!variant) return 0;
    if (variant.inventory_management !== 'shopify') return Infinity;
    if (variant.inventory_policy === 'continue') return Infinity;
    return typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : Infinity;
  }

  function parseJSONObject(value, fallback) {
    try {
      var parsed = JSON.parse(value || '');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function parseJSONArray(value, fallback) {
    try {
      var parsed = JSON.parse(value || '');
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function normalizeKey(value) {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function capitalizeFirst(value) {
    var trimmed = (value || '').trim();
    return trimmed ? trimmed.charAt(0).toUpperCase() + trimmed.slice(1) : trimmed;
  }

  // Derives a matching key ("corner turmeric yellow") from a top-view asset
  // URL (".../seat-top-corner-turmeric-yellow.png?v=123"). Ported verbatim
  // from product-seat-configurator.js's seatTopKeyFromUrl.
  function seatTopKeyFromUrl(url) {
    var path = url.split('?')[0];
    var base = path.split('/').pop() || '';
    return base
      .replace(/^seat-top-/, '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/-/g, ' ');
  }

  // Derives a matching key ("fern green") from a swatch asset URL
  // (".../swatch-fern-green.jpg?v=123"). Ported verbatim.
  function swatchKeyFromUrl(url) {
    var path = url.split('?')[0];
    var base = path.split('/').pop() || '';
    return base
      .replace(/^swatch-/, '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/-/g, ' ');
  }

  // A Color value may match a fabric photo by name (exact or partial, e.g.
  // "Fern" matches "fern green"), otherwise falls back to a solid hex color
  // if one is configured, otherwise no swatch is shown. Ported verbatim.
  function resolveColorSwatch(value, fabricSwatches) {
    var key = normalizeKey(value);
    if (!key) return null;

    if (fabricSwatches[key]) return { type: 'image', src: fabricSwatches[key] };
    for (var fabricKey in fabricSwatches) {
      if (fabricKey.indexOf(key) !== -1 || key.indexOf(fabricKey) !== -1) {
        return { type: 'image', src: fabricSwatches[fabricKey] };
      }
    }

    if (COLOR_HEX_BY_VALUE[key]) return { type: 'color', hex: COLOR_HEX_BY_VALUE[key] };

    return null;
  }

  function formatTemplate(template, values) {
    return Object.keys(values).reduce(function (out, key) {
      return out.split('{' + key + '}').join(values[key]);
    }, template || '');
  }

  function formatCents(cents) {
    return typeof window.formatMoney === 'function' ? window.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  function turn(heading, cw) {
    var i = ORDER.indexOf(heading);
    return ORDER[(i + (cw ? 1 : 3)) % 4];
  }
  function leftOf(heading) {
    return turn(heading, false);
  }
  function opposite(heading) {
    return ORDER[(ORDER.indexOf(heading) + 2) % 4];
  }
  function complement(a, b) {
    return ORDER.filter(function (d) {
      return d !== a && d !== b;
    });
  }

  // Walk the chain on a grid, heading east to start. A corner seat turns the
  // chain 90 degrees in its own direction ('R' clockwise / 'L' counter-
  // clockwise). Corner backrests always sit on the two edges NOT used to
  // join a neighbour, so a joint can never be walled off by a backrest.
  // Ported verbatim from product-seat-configurator.js's layout().
  function layout(ori, turns) {
    var cells = [];
    var x = 0;
    var y = 0;
    var heading = 'E';
    for (var i = 0; i < ori.length; i++) {
      var cell = { i: i, x: x, y: y, type: ori[i], backs: [] };
      if (ori[i] === 'A') {
        cell.backs = [leftOf(heading)];
      } else if (i === 0) {
        cell.backs = complement('E', turns[i] === 'R' ? 'S' : 'N');
      } else {
        var prevSide = opposite(heading);
        heading = turn(heading, turns[i] === 'R');
        cell.backs = complement(prevSide, heading);
      }
      cells.push(cell);
      x += DIRS[heading][0];
      y += DIRS[heading][1];
    }
    return cells;
  }

  function collides(cells) {
    var seen = {};
    for (var i = 0; i < cells.length; i++) {
      var k = cells[i].x + ',' + cells[i].y;
      if (seen[k]) return true;
      seen[k] = true;
    }
    return false;
  }

  // Alternate R / L over the turning corners (the leading end cap does not
  // turn, so it does not participate) - this staircase shape never overlaps.
  function safeTurns(ori) {
    var turns = [];
    var cw = true;
    for (var i = 0; i < ori.length; i++) {
      turns[i] = 'R';
      if (ori[i] === 'C' && i > 0) {
        turns[i] = cw ? 'R' : 'L';
        cw = !cw;
      }
    }
    return turns;
  }

  function edgeRect(dir, x, y, s) {
    var t = 11;
    if (dir === 'N') return { x: x, y: y, w: s, h: t };
    if (dir === 'S') return { x: x, y: y + s - t, w: s, h: t };
    if (dir === 'W') return { x: x, y: y, w: t, h: s };
    return { x: x + s - t, y: y, w: t, h: s };
  }

  function resolveCollisions(perModule) {
    var ori = perModule.map(function (s) {
      return s.type;
    });
    var turns = perModule.map(function (s) {
      return s.turn;
    });
    if (collides(layout(ori, turns))) {
      var safe = safeTurns(ori);
      perModule.forEach(function (s, i) {
        if (s.type === 'C') s.turn = safe[i];
      });
    }
    return perModule;
  }

  // Rotation (degrees) that moves an image authored with its backrest at the
  // top (N) - and, for corners, its arm at the left (W) - onto the cell's
  // actual back edges from layout(). Ported verbatim.
  function seatImageRotation(cell, seatType) {
    var has = {};
    cell.backs.forEach(function (d) {
      has[d] = true;
    });
    if (seatType === 'C') {
      if (has.N && has.W) return 0;
      if (has.N && has.E) return 90;
      if (has.S && has.E) return 180;
      if (has.S && has.W) return 270;
      return 0;
    }
    if (has.E) return 90;
    if (has.S) return 180;
    if (has.W) return 270;
    return 0;
  }

  // Built-in alternative arrangements for the gallery's Layout view, each
  // switched on per template by the configurator block's settings (see
  // data-layout-arrangements). An arrangement is a fixed placement for one
  // exact module chain: `types` is the C/A sequence it applies to, and
  // `cells` gives each module (in chain order) a grid position - fractions
  // allowed, for a gap between groups - and the backrest edges layout()
  // would have given it, so photos and schematics rotate the same way.
  // `baseLabel` names the plain chain it's offered next to. Purely visual:
  // the cart holds the same modules either way.
  var ARRANGEMENTS = {
    conversation: {
      types: 'CACAC',
      baseLabel: 'layoutLShape',
      label: 'layoutConversation',
      cells: [
        { x: 0, y: 0, backs: ['N', 'W'] },
        { x: 1, y: 0, backs: ['N'] },
        { x: 2, y: 0, backs: ['N', 'E'] },
        { x: 0, y: 1.6, backs: ['S'] },
        { x: 2, y: 1.6, backs: ['S', 'E'] },
      ],
    },
  };

  // Sets a slot's structural geometry fields from its shape_type - port of
  // product-seat-configurator.js's applyOrientationValue, sourcing from
  // SHAPE_TYPE_TABLE instead of a free-text Orientation option value.
  function applyShapeType(slot, shapeType) {
    var key = (shapeType || '').toLowerCase().trim();
    var preset = SHAPE_TYPE_TABLE[key];
    slot.shapeType = shapeType || null;
    if (!preset) {
      slot.type = 'A';
      slot.turn = 'R';
      slot.chaise = false;
      slot.armSide = null;
      return;
    }
    slot.type = preset.type;
    slot.turn = preset.turn || 'R';
    slot.chaise = !!preset.chaise;
    slot.armSide = preset.armSide || null;
  }

  class ModularConfiguratorV2 extends HTMLElement {
    connectedCallback() {
      var dataScript = this.querySelector('[data-module-data]');
      this.moduleData = parseJSONObject(dataScript ? dataScript.textContent : '', {});
      this.roles = Object.keys(this.moduleData);

      var seatPresetsScript = this.querySelector('[data-seat-layout-presets]');
      this.seatLayoutPresets = parseJSONObject(seatPresetsScript ? seatPresetsScript.textContent : '', {});
      // Sorted by seat_count so pills read low-to-high; presets sharing the
      // same seat_count (e.g. two different 1-seat combos) keep the order
      // the merchant configured them in, since Object.keys() preserves
      // insertion order and the sort below is stable.
      var presets = this.seatLayoutPresets;
      this.presetKeys = Object.keys(presets).sort(function (a, b) {
        return (presets[a].seat_count || 0) - (presets[b].seat_count || 0);
      });
      // Once a shell product has real seat-count presets configured, the
      // "Seats" picker takes over choosing slot count and the freeform
      // add/remove controls go away (matches the old Seats-variant
      // interaction: picking a count locks how many seats there are). Shell
      // products with no presets configured yet keep today's freeform
      // behavior untouched, so this can ship without a rollout dependency
      // across every shell product at once.
      this.locked = this.presetKeys.length > 0;
      this.selectedPresetKey = null;

      this.seatTopImages = {};
      var seatTopScript = this.querySelector('[data-seat-top-urls]');
      parseJSONArray(seatTopScript ? seatTopScript.textContent : '', []).forEach((url) => {
        this.seatTopImages[seatTopKeyFromUrl(url)] = url;
      });

      this.fabricSwatches = {};
      var fabricScript = this.querySelector('[data-fabric-swatch-urls]');
      parseJSONArray(fabricScript ? fabricScript.textContent : '', []).forEach((url) => {
        this.fabricSwatches[swatchKeyFromUrl(url)] = url;
      });

      // seat count (string) -> this shell product's own media id for that
      // count's gallery photography - see data-shell-seat-media in
      // product-block-modular-configurator.liquid. Not every count is
      // guaranteed an entry yet (merchant may not have assigned gallery media
      // to that Seats variant), so syncGalleryToSeatCount() below is a no-op
      // when one is missing.
      var shellSeatMediaScript = this.querySelector('[data-shell-seat-media]');
      this.shellSeatMedia = parseJSONObject(shellSeatMediaScript ? shellSeatMediaScript.textContent : '', {});

      this.seatCountPickerEl = this.querySelector('[data-seat-count-picker]');
      this.seatPickerStyle = (this.seatCountPickerEl && this.seatCountPickerEl.dataset.pickerStyle) || 'icons';
      this.summaryEl = this.querySelector('[data-config-summary]');
      this.globalColorsEl = this.querySelector('[data-global-colors]');
      this.colorStateEl = this.querySelector('[data-color-state]');
      this.dialog = this.querySelector('[data-customize-dialog]');
      this.dialogCanvas = this.querySelector('[data-dialog-canvas]');
      this.dialogPanel = this.querySelector('[data-dialog-panel]');
      this.dialogCount = this.querySelector('[data-dialog-count]');
      this.dialogPrice = this.querySelector('[data-dialog-price]');
      this.errorEl = this.querySelector('[data-bundle-error]');
      this.sectionId = this.dataset.section || '';
      this.priceTarget = this.dataset.priceTarget || '';
      this.priceStickyTarget = this.dataset.priceStickyTarget || '';

      // Index of the module being edited in the "Make it yours" dialog, and
      // the configuration as it was when the dialog opened - restored if the
      // shopper closes it without saving (see setupCustomizeDialog).
      this.activeSlotIndex = 0;
      this.dialogSnapshot = null;
      // Per-module colors from the last time the configuration was mixed,
      // so the "Mixed colors" swatch can bring that combination back after
      // the shopper tried a single color (see restoreMixedColors).
      this.lastMixedColors = null;
      // The single color the shopper explicitly put on every module (via
      // the "set all" swatch row, or a uniform configuration saved from the
      // dialog). Sticky across seat-count changes: selectPreset() repaints
      // a new preset in it when every module there can take it, else falls
      // back to that preset's own colors - and still keeps the preference
      // for the next switch. Cleared once the shopper chooses a mix.
      this.preferredSolidColor = null;

      this.i18n = {
        notSet: this.dataset.i18nNotSet || 'Not set',
        rotate: this.dataset.i18nRotate || 'Rotate',
        seatCount: this.dataset.i18nSeatCount || '{count} seats',
        seatCountOne: this.dataset.i18nSeatCountOne || '{count} seat',
        summary: this.dataset.i18nSummary || '{count}-module configuration · {breakdown}',
        mixedColors: this.dataset.i18nMixedColors || 'Mixed colors',
        useMixedColors: this.dataset.i18nUseMixedColors || 'Use mixed colors',
        setAllColors: this.dataset.i18nSetAllColors || 'Set all modules to {color}',
        moduleOf: this.dataset.i18nModuleOf || 'Module {index} of {total}',
        moduleCount: this.dataset.i18nModuleCount || '{count} modules',
        selectModule: this.dataset.i18nSelectModule || 'Select module {index}',
        rotateModule: this.dataset.i18nRotateModule || 'Rotate module',
        outOfStock: this.dataset.i18nOutOfStock || 'out of stock',
        notAvailableForAll: this.dataset.i18nNotAvailableForAll || 'not available for every module',
        missingVariant:
          this.dataset.i18nMissingVariant ||
          "One or more of your module selections isn't available yet.",
        genericError:
          this.dataset.i18nGenericError || 'Something went wrong adding this to your cart.',
        saveAmount: this.dataset.i18nSaveAmount || 'Save __AMOUNT__',
        galleryView: this.dataset.i18nGalleryView || 'Product view',
        inYourRoom: this.dataset.i18nInYourRoom || 'In your room',
        layoutView: this.dataset.i18nLayoutView || 'Layout view',
        layoutArrangement: this.dataset.i18nLayoutArrangement || 'Layout arrangement',
        layoutLShape: this.dataset.i18nLayoutLShape || 'L-shape',
        layoutConversation: this.dataset.i18nLayoutConversation || 'Conversation',
      };

      // perModule: one entry per configured module slot, in the order they'll
      // be added to the cart. `colorValue` is resolved via default_color /
      // fallback_priority so a slot never starts out pointing at an
      // out-of-stock variant.
      this.perModule = [];

      this.setupCustomizeDialog();
      this.setupGalleryView();

      if (this.locked) {
        this.buildSeatCountPicker();
        // data-default-preset-key (see product-block-modular-configurator.liquid)
        // lets a merchant pick which preset shows on page load instead of
        // always the lowest seat_count one; falls back to that same
        // lowest-seat_count behavior when unset or stale (pointing at a
        // preset key this product no longer lists). A ?seats=<n> URL param
        // (e.g. a marketing CTA linking to /products/ridge?seats=1) takes
        // priority over both - see presetKeyFromSeatsParam().
        var defaultKey = this.dataset.defaultPresetKey;
        var seatsParamKey = this.presetKeyFromSeatsParam();
        var initialKey = seatsParamKey
          || (defaultKey && this.presetKeys.indexOf(defaultKey) !== -1 ? defaultKey : this.presetKeys[0]);
        this.selectPreset(initialKey);
      } else {
        if (this.roles.length) {
          this.addSlot();
        }
        this.renderAll();
      }

      this.setupBundleSubmit();

      // Selecting/declining the upsell offer changes what updateComputedPrice()
      // should total - see product-upsell-offer.js, which dispatches this on
      // the upsell-offer element (bubbles to document since it's a sibling
      // block, not a descendant of this element).
      document.addEventListener('upsell-offer:change', () => {
        this.updateComputedPrice();
        this.notifyChange();
      });
    }

    // The order-quantity multiplier applied to every module line item (see
    // buildModuleCartItems) - a variant claimed by N slots at order quantity
    // Q needs N * Q units in stock, not just N.
    currentQuantity() {
      var qty = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    // How many slots currently resolve to each variant id. `skipIndex`
    // excludes one slot from the count - used when checking whether a
    // *candidate* pick for that slot would be legal, since the slot's own
    // current pick shouldn't count against itself.
    demandByVariantId(skipIndex) {
      var demand = {};
      this.perModule.forEach((slot, i) => {
        if (i === skipIndex) return;
        var variant = this.resolveVariant(slot);
        if (variant) demand[variant.id] = (demand[variant.id] || 0) + 1;
      });
      return demand;
    }

    // Tries `preferredColor` first (e.g. a seat-count preset's per-slot
    // color pick), then the role's own configured default color; if that
    // variant is unavailable *or* already fully claimed by other slots in
    // this same order (see `claimed`/`qty` below), walks fallback_priority
    // in order for the first color that still has room; failing that,
    // takes the first color with room at all. Returns null only when every
    // variant for this role is unavailable or fully claimed.
    // `preferredColor` is optional - omitting it (or passing a blank/
    // unavailable/claimed-out color) falls straight through to the existing
    // default_color/fallback_priority chain. `claimed` (variant id -> slots
    // already claiming it so far) and `qty` are optional too - callers
    // adjusting a single existing slot pass the current cross-slot demand
    // (excluding that slot itself) so a role/count change doesn't silently
    // double-book a colour another slot already has locked in.
    resolveAvailableColor(role, preferredColor, claimed, qty) {
      var mod = this.moduleData[role];
      if (!mod) return null;
      var variants = mod.variants || {};
      claimed = claimed || {};
      qty = qty || this.currentQuantity();

      var fits = function (color) {
        var variant = variants[color];
        if (!variant || !variant.available) return false;
        var limit = variantStockLimit(variant);
        if (limit === Infinity) return true;
        var already = claimed[variant.id] || 0;
        return (already + 1) * qty <= limit;
      };

      if (preferredColor && fits(preferredColor)) return preferredColor;

      if (mod.default_color && fits(mod.default_color)) return mod.default_color;

      var fallbackList = mod.fallback_priority || [];
      for (var i = 0; i < fallbackList.length; i++) {
        if (fits(fallbackList[i])) return fallbackList[i];
      }

      for (var anyColor in variants) {
        if (fits(anyColor)) return anyColor;
      }

      // Nothing currently has room (every color for this role is out of
      // stock, or already claimed by other slots at this order quantity) -
      // still resolve to *a* color instead of null, so the slot keeps its
      // top-view photo and role label. The caller/renderer marks this slot
      // unavailable via resolveVariant(slot).available, which greys out that
      // photo (see buildLayoutSvg) rather than the slot losing its image and
      // label entirely.
      return preferredColor || mod.default_color || fallbackList[0] || Object.keys(variants)[0] || null;
    }

    // Rebuilds the whole slot array from a seat-layout preset (positional:
    // roles[i] -> slot i), replacing whatever was configured before - matches
    // the old Seats-variant interaction where picking a preset is a hard
    // reset, not an incremental add/remove. `key` is the preset's own
    // identity (see data-seat-layout-presets), not the seat count - multiple
    // presets can share the same seat_count and still be distinct pills.
    selectPreset(key) {
      var preset = this.seatLayoutPresets[key] || {};
      var roles = preset.roles || [];
      var colors = preset.colors || [];
      // Tracked and updated as slots are built below (not read from
      // this.perModule, which still holds the *previous* slot set until
      // this whole assignment finishes) so an earlier slot in this same
      // preset never gets silently double-booked against a later one.
      var claimed = {};
      var qty = this.currentQuantity();
      this.perModule = roles.map((role, i) => {
        var slot = { role: role, colorValue: this.resolveAvailableColor(role, colors[i], claimed, qty), previewAngle: 0 };
        applyShapeType(slot, (this.moduleData[role] || {}).shape_type);
        var variant = this.resolveVariant(slot);
        if (variant) claimed[variant.id] = (claimed[variant.id] || 0) + 1;
        return slot;
      });
      resolveCollisions(this.perModule);
      // Checked against the freshly built slots, so a color some role here
      // doesn't come in (or can't cover at this quantity) leaves the preset's
      // own colors in place. "Mixed colors" then still offers those preset
      // colors, since lastMixedColors is reset below.
      var inheritSolid = !!this.preferredSolidColor && !this.isGlobalColorDisabled(this.preferredSolidColor);
      if (inheritSolid) {
        var solid = this.preferredSolidColor;
        this.perModule.forEach(function (slot) {
          slot.colorValue = solid;
        });
      }
      this.selectedPresetKey = key;
      this.activeSlotIndex = 0;
      this.lastMixedColors = null;
      this.updateSeatCountPicker();
      this.galleryArrangement = null;
      // Leaves the gallery on whichever view (room / layout) the shopper is
      // already on - switching seat count never flips it. The gallery itself
      // is refiltered by renderAll() -> syncGallery().
      this.renderAll();
    }

    // Refilters the room photos whenever the seat preset, the set of module
    // roles (e.g. a Corner swapped for an Armless in the dialog) or the set of
    // module colors changes - seat + module + color filtering needs all
    // three, see filterGalleryBySeatPreset in global.js - and only then, so
    // a re-render that changes none (quantity, rotation) doesn't reset the
    // slider.
    syncGallery() {
      var colors = this.distinctColors().slice().sort();
      var roles = [];
      this.perModule.forEach(function (slot) {
        if (roles.indexOf(slot.role) === -1) roles.push(slot.role);
      });
      roles.sort();
      var key = this.selectedPresetKey + '|' + roles.join(',') + '|' + colors.join(',');
      if (key === this.lastGalleryKey) return;
      this.lastGalleryKey = key;
      this.syncGalleryToPreset(this.seatLayoutPresets[this.selectedPresetKey] || {}, colors, roles);
    }

    // Picking a Seats count here doesn't touch a real Shopify variant (the
    // slots are built from role/color metaobject data, not this shell
    // product's own options), so it never runs Shopify's native variant ->
    // gallery flow (VariantSelects.updateMedia()). This drives the same
    // gallery directly instead, using the shell product's own Seats-variant
    // media map (see data-shell-seat-media).
    //
    // Tries the preset's own `label` first (downcased) - this is the only
    // field that can distinguish two presets sharing the same seat_count
    // (e.g. Arc's Cove and Nook are both seat_count 1, so keying on count
    // alone can't tell their gallery media apart) - and falls back to
    // seat_count for shell products whose preset labels don't match their
    // Seats option values verbatim (see the shell_seat_media comment in
    // product-block-modular-configurator.liquid).
    syncGalleryToPreset(preset, colors, roles) {
      // Seat renders tagged by alt text (see snippets/product-gallery-filter.liquid):
      // keep only this seat's renders plus the shared shots, and land on its
      // first render.
      if (typeof window.filterGalleryBySeatPreset === 'function') {
        // Null = nothing filtered (no tagged media); "" = seat + module +
        // color filtering applied but no seat media matched, shared shots only.
        if (window.filterGalleryBySeatPreset(this.sectionId, preset, colors, roles) != null) {
          this.showFirstGalleryMedia();
          return;
        }
      }

      if (typeof window.scrollGalleryToMedia !== 'function') return;
      var labelKey = preset.label ? String(preset.label).toLowerCase() : null;
      var mediaId = labelKey ? this.shellSeatMedia[labelKey] : null;
      if (!mediaId) mediaId = this.shellSeatMedia[String(preset.seat_count).toLowerCase()];
      if (!mediaId) return;
      window.scrollGalleryToMedia(this.sectionId, mediaId);
    }

    showFirstGalleryMedia() {
      var section = document.getElementById('MainProduct-' + this.sectionId);
      var list = section && section.querySelector('.product__media-list-wrapper > .js-media-list');
      if (!list) return;
      if (list.swiper) {
        list.swiper.slideTo(0, 0);
      } else {
        list.scroll(0, 0);
      }
    }

    // ?seats=<n> on the URL (e.g. a marketing CTA linking to
    // /products/ridge?seats=1) lets a link pick which seat-count preset to
    // land on, matched by seat_count rather than a preset's own metaobject
    // id - so whoever builds the link doesn't need to know any
    // per-product preset ids. Takes priority over data-default-preset-key
    // (see the initialKey logic in connectedCallback). Returns null when
    // the param is missing/non-numeric or no configured preset has that
    // seat_count, leaving the existing default-key/lowest-seat_count
    // fallback in place.
    presetKeyFromSeatsParam() {
      var seatsParam = new URLSearchParams(window.location.search).get('seats');
      var seatsCount = parseInt(seatsParam, 10);
      if (!seatsCount) return null;

      for (var i = 0; i < this.presetKeys.length; i++) {
        var key = this.presetKeys[i];
        if (this.seatLayoutPresets[key].seat_count === seatsCount) return key;
      }
      return null;
    }

    buildSeatCountPicker() {
      // The "Seats" step title is static Liquid output (see the
      // seats_step_heading block setting in
      // snippets/product-block-modular-configurator.liquid) - this only
      // ever populates the sibling [data-seat-count-picker] div, not the
      // title, so a merchant's richtext heading survives every rebuild.
      if (!this.seatCountPickerEl) return;
      this.seatCountPickerEl.innerHTML = '';

      this.presetKeys.forEach((key) => {
        var preset = this.seatLayoutPresets[key] || {};
        var id = 'ModularSeatCount-' + this.sectionId + '-' + key;
        var seatCount = preset.seat_count;

        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'modular-configurator__layout-input';
        input.name = 'modular-seat-count-' + this.sectionId;
        input.id = id;
        input.value = key;
        input.checked = key === this.selectedPresetKey;
        input.addEventListener('change', () => this.selectPreset(key));
        this.seatCountPickerEl.appendChild(input);

        var labelEl = document.createElement('label');
        labelEl.className =
          'modular-configurator__layout-card' +
          (this.seatPickerStyle === 'icons' ? ' modular-configurator__layout-card--icon' : '');
        labelEl.setAttribute('for', id);

        var check = document.createElement('span');
        check.className = 'modular-configurator__layout-check';
        check.innerHTML = CHECK_SVG;
        labelEl.appendChild(check);

        labelEl.appendChild(
          this.seatPickerStyle === 'icons' ? this.buildLayoutIconMedia(preset) : this.buildLayoutCardMedia(preset, key)
        );

        var text = document.createElement('span');
        text.className = 'modular-configurator__layout-label';
        text.textContent =
          preset.label ||
          formatTemplate(seatCount === 1 ? this.i18n.seatCountOne : this.i18n.seatCount, { count: seatCount });
        labelEl.appendChild(text);

        this.seatCountPickerEl.appendChild(labelEl);
      });

      // Icons style lays the cards on a grid (see the CSS): one row of
      // `count` equal columns, or - when the panel is narrow - two rows on
      // 2 * `top` columns, each card spanning two, the shorter bottom row
      // starting one column in so it sits centered under the top one.
      if (this.seatPickerStyle === 'icons') {
        var count = this.presetKeys.length;
        var top = Math.ceil(count / 2);
        this.seatCountPickerEl.style.setProperty('--seat-count', count);
        this.seatCountPickerEl.style.setProperty('--seat-split-cols', top * 2);
        var row2First = this.seatCountPickerEl.querySelectorAll('label')[top];
        if (row2First) {
          row2First.classList.add('modular-configurator__layout-card--row2-first');
          row2First.style.setProperty('--seat-row2-start', 1 + (top - (count - top)));
        }
      }
    }

    // A layout card's thumbnail: the preset's own `image` when the merchant
    // uploaded one, otherwise a schematic top-view of that preset's modules
    // (in its preset colors) so a card is never blank.
    buildLayoutCardMedia(preset, key) {
      var media = document.createElement('span');
      media.className = 'modular-configurator__layout-media';

      if (preset.image) {
        var img = document.createElement('img');
        img.src = preset.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 180;
        img.height = 120;
        media.appendChild(img);
        return media;
      }

      var colors = preset.colors || [];
      var slots = (preset.roles || []).map((role, i) => {
        var mod = this.moduleData[role] || {};
        var slot = { role: role, colorValue: colors[i] || mod.default_color, previewAngle: 0 };
        applyShapeType(slot, mod.shape_type);
        return slot;
      });
      resolveCollisions(slots);
      media.innerHTML = this.buildLayoutSvg(slots, { idSuffix: 'card-' + key, showLabels: false });
      this.attachImageFallbacks(media);
      return media;
    }

    // Icons-style thumbnail: a monochrome outline of the preset's chain, one
    // rounded square per module with a bar on each backrest edge (and a
    // shorter one on an armrest side), drawn from the same layout() walk as
    // the schematic so corners turn the same way. Colored via currentColor;
    // the preset's own `image` is deliberately ignored here.
    buildLayoutIconMedia(preset) {
      var media = document.createElement('span');
      media.className = 'modular-configurator__layout-media modular-configurator__layout-media--icon';

      var slots = (preset.roles || []).map((role) => {
        var slot = { role: role };
        applyShapeType(slot, (this.moduleData[role] || {}).shape_type);
        return slot;
      });
      if (!slots.length) return media;
      resolveCollisions(slots);
      var cells = layout(
        slots.map((s) => s.type),
        slots.map((s) => s.turn)
      );

      var S = 20; // module size
      var G = 2; // gap between modules
      var I = 2; // bar inset from the module edge
      var T = 5; // bar thickness
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      cells.forEach((c) => {
        minX = Math.min(minX, c.x);
        minY = Math.min(minY, c.y);
        maxX = Math.max(maxX, c.x);
        maxY = Math.max(maxY, c.y);
      });
      var w = (maxX - minX + 1) * (S + G) - G;
      var h = (maxY - minY + 1) * (S + G) - G;

      function bar(dir, px, py, len) {
        var off = (S - len) / 2;
        var r;
        if (dir === 'N') r = [px + off, py + I, len, T];
        else if (dir === 'S') r = [px + off, py + S - I - T, len, T];
        else if (dir === 'W') r = [px + I, py + off, T, len];
        else r = [px + S - I - T, py + off, T, len];
        return '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '" rx="1"/>';
      }

      // An armrest runs along a side edge from just past the backrest bar to
      // the inset front edge - shorter than a corner's, so the two read apart.
      function armBar(back, side, px, py) {
        var len = S - I * 2 - T - 1;
        var start = back === 'N' || back === 'W' ? I + T + 1 : I;
        var r;
        if (side === 'W') r = [px + I, py + start, T, len];
        else if (side === 'E') r = [px + S - I - T, py + start, T, len];
        else if (side === 'N') r = [px + start, py + I, len, T];
        else r = [px + start, py + S - I - T, len, T];
        return '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '" rx="1"/>';
      }

      var parts = [];
      cells.forEach((c) => {
        var slot = slots[c.i];
        var px = (c.x - minX) * (S + G);
        var py = (c.y - minY) * (S + G);
        parts.push(
          '<rect class="modular-configurator__icon-frame" x="' +
            (px + 0.5) +
            '" y="' +
            (py + 0.5) +
            '" width="' +
            (S - 1) +
            '" height="' +
            (S - 1) +
            '" rx="1.5"/>'
        );
        c.backs.forEach((d) => parts.push(bar(d, px, py, S - I * 2)));
        if (slot.type === 'A' && slot.armSide && c.backs.length) {
          parts.push(armBar(c.backs[0], slot.armSide === 'left' ? turn(c.backs[0], false) : turn(c.backs[0], true), px, py));
        }
      });

      media.innerHTML =
        '<svg class="modular-configurator__icon-svg" style="--icon-w:' +
        w +
        ';--icon-h:' +
        h +
        '" width="' +
        w +
        '" height="' +
        h +
        '" viewBox="0 0 ' +
        w +
        ' ' +
        h +
        '" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        parts.join('') +
        '</svg>';
      return media;
    }

    updateSeatCountPicker() {
      if (!this.seatCountPickerEl) return;
      this.seatCountPickerEl.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === this.selectedPresetKey;
      });
    }

    addSlot() {
      if (!this.roles.length) return;
      var role = this.roles[0];
      var slot = {
        role: role,
        colorValue: this.resolveAvailableColor(role, null, this.demandByVariantId(), this.currentQuantity()),
        previewAngle: 0,
      };
      applyShapeType(slot, (this.moduleData[role] || {}).shape_type);
      this.perModule.push(slot);
      resolveCollisions(this.perModule);
      this.renderAll();
    }

    setSlotRole(index, role) {
      var claimed = this.demandByVariantId(index);
      // Keep the module's current color when the new role offers it with
      // room to spare - swapping Corner <-> Armless shouldn't reset a color
      // the shopper already picked.
      this.galleryArrangement = null;
      var keepColor = this.perModule[index].colorValue;
      this.perModule[index].role = role;
      this.perModule[index].colorValue = this.resolveAvailableColor(role, keepColor, claimed, this.currentQuantity());
      applyShapeType(this.perModule[index], (this.moduleData[role] || {}).shape_type);
      resolveCollisions(this.perModule);
      this.renderAll();
    }

    setSlotColor(index, color) {
      this.perModule[index].colorValue = color;
      this.renderAll();
    }

    // The colors offered by the "set all modules" swatch row: only colors
    // every role in the current configuration actually comes in, in the
    // first module's own variant order.
    globalColorValues() {
      var roles = [];
      this.perModule.forEach(function (slot) {
        if (roles.indexOf(slot.role) === -1) roles.push(slot.role);
      });
      if (!roles.length) return [];

      var variantsFor = (role) => (this.moduleData[role] && this.moduleData[role].variants) || {};
      return Object.keys(variantsFor(roles[0])).filter(function (color) {
        return roles.every(function (role) {
          return !!variantsFor(role)[color];
        });
      });
    }

    // True when switching *every* module to `color` can't be fulfilled -
    // some module's variant in that color is unavailable, or the combined
    // demand of all modules (times order quantity) exceeds its stock.
    isGlobalColorDisabled(color) {
      var qty = this.currentQuantity();
      var demand = {};
      for (var i = 0; i < this.perModule.length; i++) {
        var variant = this.resolveVariant({ role: this.perModule[i].role, colorValue: color });
        if (!variant || !variant.available) return true;
        demand[variant.id] = demand[variant.id] || { count: 0, variant: variant };
        demand[variant.id].count += 1;
      }
      return Object.keys(demand).some(function (id) {
        var limit = variantStockLimit(demand[id].variant);
        return limit !== Infinity && demand[id].count * qty > limit;
      });
    }

    // Only true when no module in the configuration has this color in stock
    // at all - the "hide sold-out colors" setting drops just those. A color
    // that's merely missing for *some* modules stays visible (greyed out),
    // so the row never collapses to nothing on a product whose modules each
    // stock a different color.
    isGlobalColorSoldOut(color) {
      return this.perModule.every((slot) => {
        var variant = this.resolveVariant({ role: slot.role, colorValue: color });
        return !variant || !variant.available;
      });
    }

    setAllColors(color) {
      if (this.isGlobalColorDisabled(color)) return;
      if (this.distinctColors().length > 1) {
        this.lastMixedColors = this.perModule.map(function (slot) {
          return slot.colorValue;
        });
      }
      this.perModule.forEach(function (slot) {
        slot.colorValue = color;
      });
      this.preferredSolidColor = color;
      this.renderAll();
    }

    // What picking "Mixed colors" would set each module to: the last mixed
    // combination, else the selected preset's own colors - each resolved
    // through resolveAvailableColor so an out-of-stock (or over-claimed)
    // color falls back to that role's next available one. Null when the
    // result wouldn't actually be mixed (e.g. a preset with no colors).
    mixedColorCandidate() {
      var source = this.lastMixedColors && this.lastMixedColors.length === this.perModule.length
        ? this.lastMixedColors
        : ((this.seatLayoutPresets[this.selectedPresetKey] || {}).colors || []);
      var claimed = {};
      var qty = this.currentQuantity();
      var colors = this.perModule.map((slot, i) => {
        var color = this.resolveAvailableColor(slot.role, source[i], claimed, qty);
        var variant = this.resolveVariant({ role: slot.role, colorValue: color });
        if (variant) claimed[variant.id] = (claimed[variant.id] || 0) + 1;
        return color;
      });
      var distinct = colors.filter(function (c, i) {
        return c && colors.indexOf(c) === i;
      });
      return distinct.length > 1 ? colors : null;
    }

    restoreMixedColors() {
      var colors = this.mixedColorCandidate();
      if (!colors) return;
      this.perModule.forEach(function (slot, i) {
        slot.colorValue = colors[i];
      });
      this.preferredSolidColor = null;
      this.renderAll();
    }

    // The single color every module shares (and can actually be bought
    // in), or null when modules differ or any of them is unavailable.
    uniformColor() {
      if (!this.perModule.length) return null;
      var first = this.perModule[0].colorValue;
      var uniform = this.perModule.every((slot) => {
        var variant = this.resolveVariant(slot);
        return slot.colorValue === first && !!(variant && variant.available);
      });
      return uniform ? first : null;
    }

    distinctColors() {
      var colors = [];
      this.perModule.forEach(function (slot) {
        if (slot.colorValue && colors.indexOf(slot.colorValue) === -1) colors.push(slot.colorValue);
      });
      return colors;
    }

    // Rotates a module's top-view preview. Corner modules flip their chain
    // turn (structural - checked for collisions, since it determines which
    // way the L-shape bends); every other module just spins its own preview
    // image in place, purely cosmetic. Port of product-seat-
    // configurator.js's rotateSeat.
    rotateSlot(index) {
      var slot = this.perModule[index];
      if (!slot) return;
      this.galleryArrangement = null;

      if (slot.type !== 'C') {
        slot.previewAngle = ((slot.previewAngle || 0) + 90) % 360;
        this.renderAll();
        return;
      }

      var prevTurn = slot.turn;
      slot.turn = prevTurn === 'R' ? 'L' : 'R';

      var ori = this.perModule.map(function (s) {
        return s.type;
      });
      var turns = this.perModule.map(function (s) {
        return s.turn;
      });
      if (collides(layout(ori, turns))) {
        slot.turn = prevTurn;
        return;
      }
      this.renderAll();
    }

    renderAll() {
      this.renderSummary();
      this.renderGlobalColors();
      if (this.dialog && this.dialog.open) this.renderDialog();
      this.updateComputedPrice();
      this.updateInventoryNote();
      this.renderGalleryLayout();
      this.syncGallery();
      this.preloadSeatTopImages();
      this.notifyChange();
    }

    // "In your room / Layout view" switch on the section's main gallery
    // image: Layout view lays a live top-view of this configuration over
    // the photo slider (thumbnails and slider stay untouched underneath).
    // Only the shopper switches views (the tabs, or a thumbnail click back
    // to the room photos) - picking a seat count or colors, or saving the
    // customize dialog, keeps whichever view is showing.
    setupGalleryView() {
      this.galleryView = 'room';
      this.galleryArrangement = null;
      // Merchant toggle (block setting "layout_view_enabled", off by
      // default): without the switch the gallery stays on room photos -
      // galleryViewEl stays null, so every setGalleryView() is a no-op.
      if (this.dataset.layoutView !== 'true') return;
      var section = document.getElementById('MainProduct-' + this.sectionId);
      var mediaList = section && section.querySelector('.product__media-list-wrapper > .product__media-list');
      if (!mediaList) return;

      var root = document.createElement('div');
      root.className = 'modular-gallery-view';
      root.innerHTML =
        '<div class="modular-gallery-view__switch" role="group">' +
        '<button type="button" class="modular-gallery-view__tab" data-gallery-view="room"></button>' +
        '<button type="button" class="modular-gallery-view__tab" data-gallery-view="layout"></button>' +
        '</div>' +
        '<div class="modular-gallery-view__stage" hidden>' +
        '<div class="modular-gallery-view__canvas"></div>' +
        '<p class="modular-gallery-view__caption"></p>' +
        '<div class="modular-gallery-view__arrangements" role="group" hidden></div>' +
        '</div>';
      root.querySelector('.modular-gallery-view__switch').setAttribute('aria-label', this.i18n.galleryView);
      this.galleryTabs = root.querySelectorAll('[data-gallery-view]');
      this.galleryTabs.forEach((tab) => {
        tab.textContent = tab.dataset.galleryView === 'layout' ? this.i18n.layoutView : this.i18n.inYourRoom;
        tab.addEventListener('click', () => this.setGalleryView(tab.dataset.galleryView));
      });
      this.galleryStage = root.querySelector('.modular-gallery-view__stage');
      this.galleryCanvas = root.querySelector('.modular-gallery-view__canvas');
      this.galleryCaption = root.querySelector('.modular-gallery-view__caption');
      this.galleryArrangementsEl = root.querySelector('.modular-gallery-view__arrangements');
      this.galleryArrangementsEl.setAttribute('aria-label', this.i18n.layoutArrangement);
      this.galleryArrangementsEl.addEventListener('click', (event) => {
        var btn = event.target.closest('[data-arrangement]');
        if (!btn) return;
        this.galleryArrangement = btn.dataset.arrangement || null;
        this.renderGalleryLayout();
      });
      this.galleryViewEl = root;
      mediaList.appendChild(root);

      var thumbs = section.querySelector('.product__media-sublist');
      if (thumbs) thumbs.addEventListener('click', () => this.setGalleryView('room'));
      this.updateGalleryTabs();
    }

    setGalleryView(view) {
      if (!this.galleryViewEl || view === this.galleryView) return;
      this.galleryView = view;
      this.galleryStage.hidden = view !== 'layout';
      this.galleryViewEl.classList.toggle('modular-gallery-view--layout', view === 'layout');
      this.updateGalleryTabs();
      this.renderGalleryLayout();
    }

    updateGalleryTabs() {
      this.galleryTabs.forEach((tab) => {
        var active = tab.dataset.galleryView === this.galleryView;
        tab.classList.toggle('modular-gallery-view__tab--active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // Only redrawn while visible - switching to Layout view redraws it.
    renderGalleryLayout() {
      if (!this.galleryCanvas || this.galleryView !== 'layout') return;
      var available = this.availableArrangements();
      if (available.indexOf(this.galleryArrangement) === -1) this.galleryArrangement = null;
      var arrangement = ARRANGEMENTS[this.galleryArrangement];
      var cells = arrangement
        ? arrangement.cells.map((c, i) => ({ i: i, x: c.x, y: c.y, type: this.perModule[i].type, backs: c.backs }))
        : null;
      this.galleryCanvas.innerHTML = this.buildLayoutSvg(this.perModule, { idSuffix: 'gallery', cells: cells });
      this.attachImageFallbacks(this.galleryCanvas);
      var distinct = this.distinctColors();
      this.galleryCaption.textContent =
        formatTemplate(this.i18n.moduleCount, { count: this.perModule.length }) +
        ' · ' +
        (distinct.length === 1 ? capitalizeFirst(distinct[0]) : this.i18n.mixedColors);
      this.renderArrangementButtons(available);
    }

    // The plain chain plus every enabled arrangement that fits it, as a
    // button row under Layout view - hidden when there's nothing to switch.
    renderArrangementButtons(available) {
      var el = this.galleryArrangementsEl;
      el.hidden = !available.length;
      el.innerHTML = '';
      if (!available.length) return;
      var options = [{ key: '', label: this.i18n[ARRANGEMENTS[available[0]].baseLabel] }].concat(
        available.map((key) => ({ key: key, label: this.i18n[ARRANGEMENTS[key].label] }))
      );
      options.forEach((opt) => {
        var active = (this.galleryArrangement || '') === opt.key;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'modular-gallery-view__arrangement' + (active ? ' modular-gallery-view__arrangement--active' : '');
        btn.dataset.arrangement = opt.key;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.textContent = opt.label;
        el.appendChild(btn);
      });
    }

    // Enabled arrangements (data-layout-arrangements, read on each call)
    // whose module chain matches the current configuration exactly: same
    // C/A sequence, no chaise or arm-side modules, and corners still in
    // their default turn - once the shopper reshapes the chain in the
    // customize dialog, a fixed arrangement no longer describes it.
    availableArrangements() {
      var enabled = (this.dataset.layoutArrangements || '').split(',');
      var types = this.perModule.map(function (s) {
        return s.type;
      }).join('');
      var plain = this.perModule.every(function (s) {
        return !s.chaise && !s.armSide && (s.type !== 'C' || s.turn === 'R');
      });
      if (!plain) return [];
      return enabled
        .map(function (key) {
          return key.trim();
        })
        .filter(function (key) {
          return ARRANGEMENTS[key] && ARRANGEMENTS[key].types === types;
        });
    }

    // Warms the cache with every color's top-view photo for the roles in
    // this configuration, so a color pick swaps Layout view's photos in
    // without a half-loaded flash. Deferred to idle time to stay out of
    // the way of the page's own images.
    preloadSeatTopImages() {
      if (!this.galleryViewEl) return;
      this.preloadedSeatTops = this.preloadedSeatTops || {};
      var urls = [];
      this.perModule.forEach((slot) => {
        var variants = (this.moduleData[slot.role] && this.moduleData[slot.role].variants) || {};
        Object.keys(variants).forEach((color) => {
          var url = this.resolveSeatTopImage(slot.role, color);
          if (url && !this.preloadedSeatTops[url]) {
            this.preloadedSeatTops[url] = true;
            urls.push(url);
          }
        });
      });
      if (!urls.length) return;
      (window.requestIdleCallback || window.setTimeout)(function () {
        urls.forEach(function (url) {
          new Image().src = url;
        });
      });
    }

    // Broadcasts the current configuration as checkout-ready variant
    // quantities, for blocks that live outside this element and can't share
    // its state - e.g. the modular_shop_pay_button block
    // (assets/modular-shop-pay.js). Also kept on `this.lastChange` so a
    // listener that upgrades after the first render can read it directly.
    // `variants` is [] whenever the configuration can't be bought as-is.
    notifyChange() {
      var available = this.hasSufficientStock();
      var qty = this.currentQuantity();
      var byId = {};
      var order = [];
      var add = function (id, quantity) {
        if (!id || !quantity) return;
        if (!byId[id]) {
          byId[id] = 0;
          order.push(id);
        }
        byId[id] += quantity;
      };

      if (available) {
        this.perModule.forEach((slot) => {
          var variant = this.resolveVariant(slot);
          if (variant) add(variant.id, qty);
        });
        if (typeof window.collectUpsellCartItems === 'function') {
          window.collectUpsellCartItems().forEach(function (item) {
            add(item.id, item.quantity);
          });
        }
      }

      this.lastChange = {
        sectionId: this.sectionId,
        available: available,
        variants: order.map(function (id) {
          return { id: id, quantity: byId[id] };
        }),
      };
      this.dispatchEvent(new CustomEvent('modular-configurator:change', { bubbles: true, detail: this.lastChange }));
    }

    // "5-module configuration · 3 corner + 2 armless" - counts every role
    // any seat-layout preset uses (so a role that's currently at zero still
    // reads "+ 0 armless", matching the layout cards), or just the roles
    // present when the product has no presets.
    renderSummary() {
      if (!this.summaryEl) return;
      if (!this.perModule.length) {
        this.summaryEl.textContent = '';
        return;
      }

      var roles = [];
      var addRole = function (role) {
        if (roles.indexOf(role) === -1) roles.push(role);
      };
      this.presetKeys.forEach((key) => (this.seatLayoutPresets[key].roles || []).forEach(addRole));
      this.perModule.forEach((slot) => addRole(slot.role));

      var breakdown = roles
        .map((role) => {
          var count = this.perModule.filter((slot) => slot.role === role).length;
          var title = (this.moduleData[role] && this.moduleData[role].product_title) || role;
          return count + ' ' + String(title).toLowerCase();
        })
        .join(' + ');

      this.summaryEl.textContent = formatTemplate(this.i18n.summary, {
        count: this.perModule.length,
        breakdown: breakdown,
      });
    }

    // The "Choose your colors" row: one swatch per color every module comes
    // in (picking it sets all modules to that color), plus a non-interactive
    // "mixed" indicator that lights up whenever modules differ.
    renderGlobalColors() {
      if (!this.globalColorsEl) return;
      this.globalColorsEl.innerHTML = '';

      var uniform = this.uniformColor();
      var distinct = this.distinctColors();
      var mixed = !uniform && distinct.length > 1;

      this.globalColorValues().forEach((color) => {
        var soldOut = this.isGlobalColorSoldOut(color);
        this.globalColorsEl.appendChild(
          this.buildSwatchButton(color, {
            active: uniform === color,
            disabled: this.isGlobalColorDisabled(color),
            soldOut: soldOut,
            disabledReason: soldOut ? this.i18n.outOfStock : this.i18n.notAvailableForAll,
            label: formatTemplate(this.i18n.setAllColors, { color: capitalizeFirst(color) }),
            onPick: () => this.setAllColors(color),
          })
        );
      });

      if (this.perModule.length > 1) {
        var candidate = mixed ? null : this.mixedColorCandidate();
        var mixedEl = document.createElement('button');
        mixedEl.type = 'button';
        mixedEl.className =
          'modular-configurator__swatch-btn modular-configurator__swatch-btn--mixed' +
          (mixed ? ' modular-configurator__swatch-btn--on' : '') +
          (!mixed && !candidate ? ' modular-configurator__swatch-btn--disabled' : '');
        mixedEl.setAttribute('aria-label', this.i18n.useMixedColors);
        mixedEl.setAttribute('aria-pressed', String(mixed));
        mixedEl.title = this.i18n.mixedColors;
        mixedEl.disabled = !mixed && !candidate;
        if (candidate) mixedEl.addEventListener('click', () => this.restoreMixedColors());

        var mosaic = document.createElement('span');
        mosaic.className = 'modular-configurator__swatch modular-configurator__swatch--mosaic';
        // Up to four tiles: the colors in this configuration when it's
        // mixed, otherwise a preview of what picking "mixed" would restore.
        var tilesSource = mixed ? distinct : candidate || this.globalColorValues();
        var tiles = tilesSource.filter(function (c, i) {
          return tilesSource.indexOf(c) === i;
        }).slice(0, 4);
        tiles.forEach((color) => {
          var tile = document.createElement('span');
          this.paintSwatch(tile, color);
          mosaic.appendChild(tile);
        });
        mixedEl.appendChild(mosaic);
        this.globalColorsEl.appendChild(mixedEl);
      }

      if (this.colorStateEl) {
        this.colorStateEl.textContent = uniform
          ? capitalizeFirst(uniform)
          : mixed
          ? this.i18n.mixedColors
          : this.i18n.notSet;
      }
    }

    setupCustomizeDialog() {
      var openBtn = this.querySelector('[data-customize-open]');
      if (!this.dialog || !openBtn) return;

      openBtn.addEventListener('click', () => this.openCustomizeDialog());
      this.querySelector('[data-customize-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-customize-save]').addEventListener('click', () => {
        this.dialogSnapshot = null;
        // Saving per-module edits is an explicit pick: one color everywhere
        // becomes the sticky solid preference, anything mixed drops it.
        this.preferredSolidColor = this.uniformColor();
        this.dialog.close();
      });

      // Backdrop click: the <dialog> itself is the only thing under the
      // pointer outside .modular-configurator__dialog-inner.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // Fires for every way out - close button, Escape, backdrop, save. Only
      // save clears the snapshot, so anything else rolls the edits back.
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('overflow-hidden');
        if (this.dialogSnapshot) {
          this.perModule = this.dialogSnapshot;
          this.dialogSnapshot = null;
          this.renderAll();
        }
      });

      this.dialogCanvas.addEventListener('click', (event) => {
        var cell = event.target.closest('[data-slot-index]');
        if (cell) this.selectModule(parseInt(cell.getAttribute('data-slot-index'), 10));
      });
      this.dialogCanvas.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var cell = event.target.closest('[data-slot-index]');
        if (!cell) return;
        event.preventDefault();
        this.selectModule(parseInt(cell.getAttribute('data-slot-index'), 10), true);
      });
    }

    openCustomizeDialog() {
      if (!this.perModule.length) return;
      this.dialogSnapshot = this.perModule.map(function (slot) {
        return Object.assign({}, slot);
      });
      if (this.activeSlotIndex >= this.perModule.length) this.activeSlotIndex = 0;
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
      this.renderDialog();
    }

    selectModule(index, keepFocus) {
      if (isNaN(index) || !this.perModule[index]) return;
      this.activeSlotIndex = index;
      this.renderDialog();
      if (keepFocus) {
        var cell = this.dialogCanvas.querySelector('[data-slot-index="' + index + '"]');
        if (cell) cell.focus();
      }
    }

    renderDialog() {
      if (!this.dialog) return;
      var index = this.activeSlotIndex;
      var slot = this.perModule[index];
      if (!slot) return;

      // Re-rendering replaces the controls, so remember which one had focus
      // (e.g. a swatch picked via keyboard) and restore it afterwards.
      var focused = this.dialog.contains(document.activeElement)
        ? document.activeElement.getAttribute('data-focus-key')
        : null;

      this.dialogCanvas.innerHTML = this.buildLayoutSvg(this.perModule, {
        idSuffix: 'dialog',
        interactive: true,
        activeIndex: index,
      });
      this.attachImageFallbacks(this.dialogCanvas);

      var panel = this.dialogPanel;
      panel.innerHTML = '';

      var mod = this.moduleData[slot.role] || {};
      var variant = this.resolveVariant(slot);
      var colorAvailable = !!(variant && variant.available);

      var eyebrow = document.createElement('p');
      eyebrow.className = 'modular-configurator__panel-eyebrow';
      eyebrow.textContent = formatTemplate(this.i18n.moduleOf, { index: index + 1, total: this.perModule.length });
      panel.appendChild(eyebrow);

      var title = document.createElement('h3');
      title.className = 'modular-configurator__panel-title';
      title.textContent = colorAvailable ? capitalizeFirst(slot.colorValue) : this.i18n.notSet;
      panel.appendChild(title);

      // lock_style roles (e.g. Arc's Cove/Nook) are distinct products, not
      // interchangeable styles - no role switch and no rotate for them.
      if (!mod.lock_style && this.roles.length > 1) {
        var roleRow = document.createElement('div');
        roleRow.className = 'modular-configurator__role-row';
        this.roles.forEach((role) => {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className =
            'modular-configurator__role-btn' + (slot.role === role ? ' modular-configurator__role-btn--on' : '');
          btn.textContent = (this.moduleData[role] && this.moduleData[role].product_title) || role;
          btn.setAttribute('aria-pressed', String(slot.role === role));
          btn.setAttribute('data-focus-key', 'role-' + role);
          btn.addEventListener('click', () => {
            if (slot.role !== role) this.setSlotRole(index, role);
          });
          roleRow.appendChild(btn);
        });
        panel.appendChild(roleRow);
      }

      var swatchRow = document.createElement('div');
      swatchRow.className = 'modular-configurator__swatch-row';
      var variants = mod.variants || {};
      Object.keys(variants).forEach((color) => {
        var v = variants[color];
        swatchRow.appendChild(
          this.buildSwatchButton(color, {
            active: colorAvailable && slot.colorValue === color,
            disabled: this.isColorDisabled(slot.role, color, index),
            soldOut: !v || !v.available,
            label: capitalizeFirst(color),
            focusKey: 'color-' + color,
            onPick: () => this.setSlotColor(index, color),
          })
        );
      });
      panel.appendChild(swatchRow);

      if (!mod.lock_style) {
        var rotateBtn = document.createElement('button');
        rotateBtn.type = 'button';
        rotateBtn.className = 'modular-configurator__rotate-btn';
        rotateBtn.setAttribute('data-focus-key', 'rotate');
        rotateBtn.innerHTML = ROTATE_SVG + '<span></span>';
        rotateBtn.lastChild.textContent = this.i18n.rotateModule;
        rotateBtn.addEventListener('click', () => this.rotateSlot(index));
        // Rapid clicks read as a double/triple click, which would select
        // the panel's text - the panel is rebuilt on every rotate, so the
        // selection can spread past the button itself.
        rotateBtn.addEventListener('mousedown', (event) => {
          if (event.detail > 1) event.preventDefault();
        });
        panel.appendChild(rotateBtn);
      }

      if (this.dialogCount) {
        this.dialogCount.textContent = formatTemplate(this.i18n.moduleCount, { count: this.perModule.length });
      }
      if (this.dialogPrice) {
        var totals = this.computeTotals();
        this.dialogPrice.textContent = totals ? formatCents(totals.total) : '';
      }

      if (focused) {
        var target = this.dialog.querySelector('[data-focus-key="' + focused + '"]');
        if (target) target.focus();
      }
    }

    // True when every currently configured slot resolves to a variant that
    // both has stock at all *and* isn't already oversubscribed once every
    // slot claiming it (times the order quantity) is added up - the same
    // aggregate-demand check the swatch picker uses to grey out choices,
    // applied here to the configuration as a whole (including slots the
    // shopper never touched, e.g. straight from a seat-count preset).
    hasSufficientStock() {
      if (!this.perModule.length) return false;
      var qty = this.currentQuantity();
      var demand = {};
      var allResolved = true;

      this.perModule.forEach((slot) => {
        var variant = this.resolveVariant(slot);
        if (!variant || !variant.available) {
          allResolved = false;
          return;
        }
        demand[variant.id] = demand[variant.id] || { count: 0, variant: variant };
        demand[variant.id].count += 1;
      });

      if (!allResolved) return false;

      return Object.keys(demand).every((id) => {
        var entry = demand[id];
        var limit = variantStockLimit(entry.variant);
        return limit === Infinity || entry.count * qty <= limit;
      });
    }

    // True when any currently configured slot resolves to a variant flagged
    // with the custom.extended_lead_time metafield (see variant_value_json
    // in product-block-modular-configurator.liquid) - a merchant-marked
    // "sellable but on a longer freight lead time" variant, e.g. a color
    // pre-sold ahead of its real restock. One flagged slot is enough to push
    // the whole order onto the longer timeline, since every slot ships
    // together.
    hasExtendedLeadTime() {
      return this.perModule.some((slot) => {
        var variant = this.resolveVariant(slot);
        return !!(variant && variant.extended_lead_time);
      });
    }

    // Mirrors the standard `inventory` block's dot-color states
    // (products__inventory-inner--empty for out-of-stock), but computed
    // from whether every currently configured module resolves to an
    // available variant with enough stock left to cover this order - this
    // shell product has no single "inventory quantity" of its own, so
    // there's no "low stock" (--error) tier here, only available vs. not.
    updateInventoryNote() {
      var el = document.getElementById('ModularInventory-' + this.sectionId);
      var inner = el ? el.querySelector('[data-modular-inventory-inner]') : null;
      if (!inner) return;

      inner.classList.toggle('product__inventory-inner--empty', !this.hasSufficientStock());
      inner.classList.toggle('product__inventory-inner--extended-lead', this.hasExtendedLeadTime());
    }

    // Finds the top-view photo for a role + color combination: exact key
    // first ("anchor-corner-1 turmeric yellow"), then a handle-only image
    // (e.g. an ottoman). Returns null when nothing fits, in which case the
    // cell falls back to the schematic shape. Keyed by the role's atomic
    // module product handle (this.moduleData[role].product_handle), not the
    // merchant-entered role name - see data-shell-seat-media in
    // product-block-modular-configurator.liquid for why (role names collide
    // across shell products, product handles never do). Falls back to the
    // role string itself if module data is missing for some reason.
    resolveSeatTopImage(role, colorValue) {
      var images = this.seatTopImages;
      var mod = this.moduleData[role];
      var handle = (mod && mod.product_handle) || role;
      var r = normalizeKey(handle);
      var c = normalizeKey(colorValue);
      if (!r) return null;

      if (c && images[r + ' ' + c]) return images[r + ' ' + c];
      if (images[r]) return images[r];
      return null;
    }

    // Builds the top-view SVG markup for `perModule` (the live
    // configuration, or a preset's slots for a layout card thumbnail). Port
    // of product-seat-configurator.js's renderCanvas, keyed by
    // role/shapeType instead of orientationValue. Every cell also renders
    // its schematic fallback group (hidden if a photo resolved) so a 404'd
    // <image> - photo URLs are dynamically constructed from merchant
    // metaobject data rather than a hand-verified list - can be swapped to
    // it by attachImageFallbacks() instead of showing a broken image.
    // options:
    //   idSuffix         - keeps <pattern> ids unique per rendered SVG
    //   interactive      - wraps each cell in a focusable [data-slot-index]
    //   activeIndex      - draws a selection outline around that cell
    //   markUnavailable  - stripe out-of-stock cells (default true)
    //   cells            - fixed placements to draw instead of walking the
    //                      chain (see ARRANGEMENTS)
    buildLayoutSvg(perModule, options) {
      options = options || {};
      if (!perModule.length) return '';

      var cells = options.cells;
      if (!cells) {
        var ori = perModule.map(function (s) {
          return s.type;
        });
        var turns = perModule.map(function (s) {
          return s.turn;
        });
        cells = layout(ori, turns);
      }

      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      cells.forEach(function (c) {
        minX = Math.min(minX, c.x);
        maxX = Math.max(maxX, c.x);
        minY = Math.min(minY, c.y);
        maxY = Math.max(maxY, c.y);
      });
      var cols = maxX - minX + 1;
      var rows = maxY - minY + 1;
      var w = cols * CELL + (cols - 1) * GAP + PAD * 2;
      var h = rows * CELL + (rows - 1) * GAP + PAD * 2;

      // Namespaced per section so multiple configurators on one page (e.g.
      // theme editor previews) don't collide on the same <pattern> id.
      var stripesId = 'seat-stripes-' + this.sectionId + '-' + (options.idSuffix || 'main');

      var svg = [
        '<svg class="seat-configurator__svg modular-configurator__svg" width="' +
          w +
          '" height="' +
          h +
          '" viewBox="0 0 ' +
          w +
          ' ' +
          h +
          '" xmlns="http://www.w3.org/2000/svg" role="' +
          (options.interactive ? 'group' : 'img') +
          '" aria-label="Sofa layout preview">',
        '<defs><pattern id="' +
          stripesId +
          '" width="6" height="6" patternTransform="rotate(45)" patternUnits="userSpaceOnUse">' +
          '<rect width="6" height="6" class="seat-configurator__stripe-bg"/>' +
          '<line x1="0" y1="0" x2="0" y2="6" class="seat-configurator__stripe-line"/>' +
          '</pattern></defs>',
      ];


      cells.forEach((c) => {
        var px = PAD + (c.x - minX) * (CELL + GAP);
        var py = PAD + (c.y - minY) * (CELL + GAP);
        var slot = perModule[c.i];
        var isC = slot.type === 'C';
        var isChaise = isC && slot.chaise;
        var suffix = isChaise ? '--chaise' : isC ? '--corner' : '';
        var typeLabel = isChaise
          ? 'Chaise'
          : isC
          ? 'Corner'
          : slot.armSide
          ? slot.armSide + ' arm'
          : 'Armless';

        var imageSrc = this.resolveSeatTopImage(slot.role, slot.colorValue);
        var variant = this.resolveVariant(slot);
        var isUnavailable = options.markUnavailable !== false && (!variant || !variant.available);
        var cellClass = 'seat-configurator__cell' + (isUnavailable ? ' seat-configurator__cell--unavailable' : '');
        var deg = (seatImageRotation(c, slot.type) + (slot.previewAngle || 0)) % 360;
        var cx = px + CELL / 2;
        var cy = py + CELL / 2;
        // Diagonal-stripe overlay so "unavailable" reads correctly even over
        // a photo whose fabric already happens to be grey - plain
        // grayscale/opacity alone is ambiguous in that case.
        var stripeRect = isUnavailable
          ? '<rect class="seat-configurator__cell-stripes" x="' +
            px +
            '" y="' +
            py +
            '" width="' +
            CELL +
            '" height="' +
            CELL +
            '" rx="8" style="fill:url(#' +
            stripesId +
            ')"/>'
          : '';

        if (options.interactive) {
          svg.push(
            '<g class="modular-configurator__cell-hit' +
              (options.activeIndex === c.i ? ' modular-configurator__cell-hit--active' : '') +
              '" data-slot-index="' +
              c.i +
              '" tabindex="0" role="button" aria-pressed="' +
              (options.activeIndex === c.i) +
              '" aria-label="' +
              formatTemplate(this.i18n.selectModule, { index: c.i + 1 }) +
              '">'
          );
        }

        if (imageSrc) {
          svg.push('<g class="' + cellClass + '" data-cell-image="' + c.i + '">');
          svg.push(
            '<g transform="rotate(' +
              deg +
              ' ' +
              cx +
              ' ' +
              cy +
              ')"><image href="' +
              imageSrc +
              '" x="' +
              px +
              '" y="' +
              py +
              '" width="' +
              CELL +
              '" height="' +
              CELL +
              '" preserveAspectRatio="xMidYMid meet"/>' +
              stripeRect +
              '</g>'
          );
          svg.push(
            '<circle class="seat-configurator__cell-badge" cx="' +
              (px + 12) +
              '" cy="' +
              (py + 12) +
              '" r="9"/>'
          );
          svg.push(
            '<text class="seat-configurator__cell-badge-num" x="' +
              (px + 12) +
              '" y="' +
              (py + 15.5) +
              '" text-anchor="middle">' +
              (c.i + 1) +
              '</text>'
          );
          svg.push('</g>');
        }

        svg.push(
          '<g class="' +
            cellClass +
            '" data-cell-schematic="' +
            c.i +
            '"' +
            (imageSrc ? ' style="display:none"' : '') +
            '>'
        );
        svg.push('<g transform="rotate(' + deg + ' ' + cx + ' ' + cy + ')">');
        svg.push(
          '<rect class="seat-configurator__cell-rect seat-configurator__cell-rect' +
            suffix +
            '" x="' +
            px +
            '" y="' +
            py +
            '" width="' +
            CELL +
            '" height="' +
            CELL +
            '" rx="8"/>' +
            stripeRect
        );

        c.backs.forEach(function (d) {
          var r = edgeRect(d, px + 3, py + 3, CELL - 6);
          svg.push(
            '<rect class="seat-configurator__cell-back seat-configurator__cell-back' +
              suffix +
              '" x="' +
              r.x +
              '" y="' +
              r.y +
              '" width="' +
              r.w +
              '" height="' +
              r.h +
              '" rx="4"/>'
          );
        });
        svg.push('</g>');

        svg.push(
          '<text class="seat-configurator__cell-num seat-configurator__cell-num' +
            suffix +
            '" x="' +
            (px + CELL / 2) +
            '" y="' +
            (py + CELL / 2 + 1) +
            '" text-anchor="middle">' +
            (c.i + 1) +
            '</text>'
        );
        svg.push(
          '<text class="seat-configurator__cell-type seat-configurator__cell-type' +
            suffix +
            '" x="' +
            (px + CELL / 2) +
            '" y="' +
            (py + CELL / 2 + 17) +
            '" text-anchor="middle">' +
            typeLabel.toUpperCase() +
            '</text>'
        );

        svg.push('</g>');

        if (options.interactive) {
          svg.push(
            '<rect class="modular-configurator__cell-outline" x="' +
              (px + 1) +
              '" y="' +
              (py + 1) +
              '" width="' +
              (CELL - 2) +
              '" height="' +
              (CELL - 2) +
              '" rx="6"/>'
          );
          svg.push('</g>');
        }
      });

      svg.push('</svg>');
      return svg.join('');
    }

    // Swaps a cell's 404'd top-view photo for its schematic fallback group
    // (see buildLayoutSvg) - call after inserting the SVG into `container`.
    attachImageFallbacks(container) {
      container.querySelectorAll('[data-cell-image]').forEach(function (imageGroup) {
        var imageEl = imageGroup.querySelector('image');
        if (!imageEl) return;
        imageEl.addEventListener('error', function () {
          var schematicGroup = imageGroup.parentNode.querySelector(
            '[data-cell-schematic="' + imageGroup.getAttribute('data-cell-image') + '"]'
          );
          imageGroup.style.display = 'none';
          if (schematicGroup) schematicGroup.style.display = '';
        });
      });
    }

    // True when picking `value` for the module at `index` isn't possible
    // right now - either the variant itself has no stock at all, or every
    // unit it does have is already spoken for by this order's other slots.
    // The slot's own current pick is never disabled (reselecting what's
    // already chosen can't make demand any worse).
    isColorDisabled(role, value, index) {
      var mod = this.moduleData[role];
      var variant = mod && mod.variants && mod.variants[value];
      if (!variant) return true;
      if (!variant.available) return true;

      var slot = this.perModule[index];
      if (slot && slot.colorValue === value) return false;

      var limit = variantStockLimit(variant);
      if (limit === Infinity) return false;

      var claimed = this.demandByVariantId(index)[variant.id] || 0;
      return (claimed + 1) * this.currentQuantity() > limit;
    }

    // Fills `el` with a color's fabric photo, or its solid hex color when
    // one is configured in COLOR_HEX_BY_VALUE.
    paintSwatch(el, color) {
      var swatch = resolveColorSwatch(color, this.fabricSwatches);
      if (swatch && swatch.type === 'image') {
        el.style.backgroundImage = 'url(' + swatch.src + ')';
      } else if (swatch && swatch.type === 'color') {
        el.style.backgroundColor = swatch.hex;
      }
    }

    // One square color swatch button, shared by the set-all-modules row and
    // the per-module dialog. `disabled` greys it out (no stock, or every
    // unit already claimed by this order's other modules); `soldOut` also
    // lets the "hide sold-out colors" theme setting drop it entirely.
    buildSwatchButton(color, opts) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'modular-configurator__swatch-btn' +
        (opts.active ? ' modular-configurator__swatch-btn--on' : '') +
        (opts.disabled ? ' modular-configurator__swatch-btn--disabled' : '') +
        (opts.soldOut ? ' modular-configurator__swatch-btn--soldout' : '');
      btn.setAttribute('aria-label', opts.label);
      btn.setAttribute('aria-pressed', String(!!opts.active));
      if (opts.focusKey) btn.setAttribute('data-focus-key', opts.focusKey);
      btn.title = opts.disabled ? opts.label + ' - ' + (opts.disabledReason || this.i18n.outOfStock) : opts.label;
      btn.disabled = !!opts.disabled;

      var swatchEl = document.createElement('span');
      swatchEl.className = 'modular-configurator__swatch';
      this.paintSwatch(swatchEl, color);
      btn.appendChild(swatchEl);

      if (!opts.disabled) btn.addEventListener('click', opts.onPick);
      return btn;
    }

    resolveVariant(slot) {
      var mod = this.moduleData[slot.role];
      if (!mod) return null;
      return (mod.variants && mod.variants[slot.colorValue]) || null;
    }

    // Sum (in cents) of what each configured module costs, plus any
    // selected upsell - the number buildModuleCartItems() actually charges.
    // Null while any module doesn't resolve to a variant.
    computeTotals() {
      var total = 0;
      var compareTotal = 0;
      var allFound = this.perModule.length > 0;

      this.perModule.forEach((slot) => {
        var variant = this.resolveVariant(slot);
        if (!variant) {
          allFound = false;
          return;
        }
        total += variant.price;
        compareTotal += variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      });

      if (!allFound) return null;

      // Fold in any selected modular_upsell_offer block (see
      // product-block-modular-upsell.liquid / product-upsell-offer.js) -
      // it's a sibling block, not a child of this element, so it's looked
      // up on the page rather than within this.perModule.
      document.querySelectorAll('upsell-offer').forEach((el) => {
        if (!el.quantity || !el.price) return;
        total += el.price * el.quantity;
        compareTotal += (el.compareAtPrice > el.price ? el.compareAtPrice : el.price) * el.quantity;
      });

      return { total: total, compareTotal: compareTotal };
    }

    // Mirrors product-seat-configurator.js's updateComputedPrice: replaces the
    // PDP's single-variant price with the sum of what each configured module
    // actually costs, since that's the number buildModuleCartItems() charges.
    updateComputedPrice() {
      var priceWrapper = this.priceTarget ? document.getElementById(this.priceTarget) : null;
      var stickyWrapper = this.priceStickyTarget ? document.getElementById(this.priceStickyTarget) : null;
      if (!priceWrapper && !stickyWrapper) return;

      var totals = this.computeTotals();
      if (!totals) return;

      window.updateConfiguredPriceDisplay({
        priceWrapper: priceWrapper,
        stickyWrapper: stickyWrapper,
        total: totals.total,
        compareTotal: totals.compareTotal,
        sectionId: this.sectionId,
        saveAmountTemplate: this.i18n.saveAmount,
      });
    }

    buildModuleCartItems(quantity) {
      // Final safety net - the swatch picker already disables choices that
      // would oversubscribe a variant, but this re-checks the full
      // configuration against real stock right before submit (e.g. in case
      // the shopper bumped the order quantity after picking colors).
      if (!this.hasSufficientStock()) return null;

      var bundleId = 'mc-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
      var items = [];

      for (var i = 0; i < this.perModule.length; i++) {
        var variant = this.resolveVariant(this.perModule[i]);

        items.push({
          id: variant.id,
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_index: i + 1,
            _bundle_total: this.perModule.length,
            _bundle_title: this.dataset.bundleTitle || '',
          },
        });
      }

      return items;
    }

    setupBundleSubmit() {
      var form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;
      var submitBtn = form.querySelector('[name="add"]');
      if (!submitBtn) return;

      this.form = form;
      this.submitBtn = submitBtn;
      // Lives in the modular_shipping_note block, not inside this form (it's
      // only form-associated via its `form="..."` attribute), so it must be
      // looked up by id rather than via form.querySelector.
      this.quantityInput = document.getElementById('Quantity-' + this.sectionId);

      // Demand vs. stock scales with order quantity (see currentQuantity),
      // so bumping the stepper can turn an already-picked color into an
      // over-quota one - re-render to refresh swatch disabled-states and
      // the shipping note.
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', () => this.renderAll());
      }

      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.submitCartBundle({
          form: this.form,
          submitBtn: this.submitBtn,
          errorEl: this.errorEl,
          quantityInput: this.quantityInput,
          buildItems: (quantity) => {
            var items = this.buildModuleCartItems(quantity);
            if (!items) return items;
            // See assets/product-upsell-offer.js - folds a selected
            // modular_upsell_offer block's variant into this same bundle so
            // it's added to cart in the same request as the main product.
            if (typeof window.collectUpsellCartItems === 'function') {
              items = items.concat(window.collectUpsellCartItems());
            }
            return items;
          },
          i18n: this.i18n,
          source: 'modular-configurator',
        });
      });
    }
  }

  customElements.define('modular-configurator-v2', ModularConfiguratorV2);
})();
